import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UserPasswordChangeComponent} from "./user-password-change";
import {UserPersonalDataComponent} from "./user-personal-data";
import {UserContactDataComponent} from "./user-contact-data";
import {BankAccountService} from "../accounts/bank-account-service";
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'dk-user-details',
    template: require('./user-details.html'),
    providers: [BankAccountService]
})

export class UserDetailsComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private bankAccountService: BankAccountService,
        private router: Router) {

    }

    smsMode1: boolean;
    smsMode2: boolean;
    smsMode3: boolean;
    smsMode4: boolean;

    public ngOnInit() {
        if (this.route.snapshot.params['check'] === '1') {
            this.bankAccountService.isAccountActive().subscribe(result => {
                if (result) {
                    this.router.navigate(['/panel-klienta/moj-portfel.html']);
                }
            });
        }
    }
}
